export const getCustomerTypeColor = (type: string | undefined): string => {
  switch (type?.toLowerCase()) {
    case 'residential':
    case 'residential owner':
      return '#4CAF50';
    case 'commercial':
    case 'commercial owner':
      return '#2196F3';
    case 'enterprise':
      return '#1976D2';
    case 'industrial':
      return '#FF9800';
    case 'food service':
      return '#E91E63';
    case 'retail owner':
      return '#9C27B0';
    case 'reit':
      return '#795548';
    case 'mid-market':
      return '#607D8B';
    case 'startup':
      return '#00BCD4';
    default:
      return '#9E9E9E';
  }
};